import Div from 'src/components/atomic/atom/Div'
import Svg from 'src/components/atomic/atom/Svg'
import Span from 'src/components/atomic/atom/Span'
import CheckBox from 'src/components/atomic/atom/CheckBox'
import useMediaQueryHook from 'src/hooks/useMediaQuery.hook'
import { COLOR } from 'src/constants/colors'
import { useAppSelector } from 'src/hooks/redux/useAppSelector'
import { RootState } from 'src/store/store'
import { MouseEvent } from 'react'
import { ExplorerDetailDataPropsType } from 'src/views/Service/Explorer/Detail'
import { DirInfosType, FileInfosType } from 'src/types/websocket'

const ExplorerDetailContents = (props: { data: ExplorerDetailDataPropsType }) => {
  const { ExtensionSvgHandler, fileSizeHandler, FolderInnerDispatch, eachCheckboxHandler } =
    props.data
  const { FileInfos, DirInfos } = useAppSelector((state: RootState) => state.explorerFileList)
  const { setMediaStyle, currentMedia } = useMediaQueryHook()

  const ContentsBoxStyle = {
    display: 'flex',
    width: '100%',
    height: setMediaStyle('48px', '51px', '51px'),
    userSelect: 'none',
    gap: '10px',
  }

  const SvgBgStyle = {
    borderRadius: '6px',
    backgroundColor: COLOR.black8,
    minWidth: '48px',
    width: '48px',
    height: '48px',
    margin: 'auto 0',
  }

  const SpanStyle = {
    textAlign: 'left',
    width: currentMedia === 'min' ? '190px' : setMediaStyle('308px', '', '232px'),
  }

  return (
    <Div
      width={'100%'}
      display={'flex'}
      $flex_wrap={'wrap'}
      $gap={setMediaStyle('20px', '12px', '12px')}
    >
      {DirInfos?.map((element: DirInfosType, index: number) => (
        <Div key={index} style={ContentsBoxStyle} onClick={() => FolderInnerDispatch(element.Name)}>
          <Svg name={'file_grey'} width={'24'} height={'24'} style={SvgBgStyle} />
          <Span
            option={setMediaStyle('mediumLarge_bold', 'small_bold', 'small_bold')}
            $line_height={setMediaStyle('48px', '51px', '51px')}
            style={SpanStyle}
            ellipsis={1}
          >
            {element.Name}
          </Span>
        </Div>
      ))}
      {FileInfos?.map((element: FileInfosType, index: number) => (
        <Div key={index} style={ContentsBoxStyle} $justify_content={'space-between'}>
          <Div display={'flex'} $gap={'10px'}>
            <Svg
              name={ExtensionSvgHandler(element.Extension)}
              color={COLOR.black40}
              style={SvgBgStyle}
            />
            <Div>
              <Span
                option={setMediaStyle('mediumLarge_bold', 'small_bold', 'small_bold')}
                style={SpanStyle}
                ellipsis={1}
              >
                {element.Name}.{element.Extension}
              </Span>
              <Span option={'mini'} $text_align={'left'} color={COLOR.black40}>
                {fileSizeHandler(element.Size)}
              </Span>
            </Div>
          </Div>
          <CheckBox
            size={'20px'}
            checked={element.check}
            onChange={() => {}}
            onMouseDown={(event: MouseEvent<HTMLLabelElement, MouseEvent>) =>
              eachCheckboxHandler(event, index)
            }
          />
        </Div>
      ))}
    </Div>
  )
}
export default ExplorerDetailContents
